module.exports = __webpack_public_path__ + "img/check-circle.4aa3acd8.svg";